import * as avb from './AVB';
import * as cvb from './CVB';
import * as agency from './Agency';
import * as client from './Client';

export const route = {
  path: 'guarantee',
  children: [avb.route, cvb.route, agency.route, client.route],
};
